export default class DomElementsBase {
	constructor($module, selectors) {
		if (this.constructor === DomElementsBase) {
			throw new Error("Cannot instantiate abstract base class.");
		}

		if (!selectors) {
			throw new Error("Classes inheriting DomElementsBase needs to define a list of selectors.");
		}

		if (!$module) {
			throw new Error("Classes inheriting DomElementsBase needs to define a root module.");
		}

		this.elementMap = [];

		selectors.map((selector) => {
			this.elementMap[selector] = null;
		});

		this.$module = $module;
	}

	_getElementChildrenByTagKey(selector, tag) {
		return `children_by_tag_${selector}_${tag}`;
	}

	_getDomElement(selector) {
		return this.$module.querySelector(selector);
	}

	_getDomElements(selector) {
		return this.$module.querySelectorAll(selector);
	}

	_get(callback, selector, forceRefresh) {
		const cachedElement = forceRefresh ? null : this.elementMap[selector];

		if (cachedElement) {
			return cachedElement;
		}

		const result = callback(selector);

		if (result === null) {
			console.log(`No element found with selector: '${selector}'`); // eslint-disable-line no-console
		}

		this.elementMap[selector] = result;

		return result;
	}

	getModuleElement() {
		return this.$module;
	}

	getElement(selector, forceRefresh = false) {
		return this._get(this._getDomElement.bind(this), selector, forceRefresh);
	}

	getElements(selector, forceRefresh = false) {
		return this._get(this._getDomElements.bind(this), selector, forceRefresh);
	}

	getChildrenByTag(selector, tag, forceRefresh = false) {
		const key = this._getElementChildrenByTagKey(selector, tag);
		const cachedElements = forceRefresh ? null : this.elementMap[key];

		if (cachedElements) {
			return cachedElements;
		}

		const $root = this._get(this._getDomElement.bind(this), selector, forceRefresh);

		if (!$root) {
			return [];
		}

		const $elements = Array.prototype.filter.call($root.children, (child) => {
			return child.matches(tag);
		});

		this.elementMap[key] = $elements;

		return this.elementMap[key];
	}

	getDescendentsByTag(selector, tag, forceRefresh = false) {
		const key = this._getElementChildrenByTagKey(selector, tag);
		const cachedElements = forceRefresh ? null : this.elementMap[key];

		if (cachedElements) {
			return cachedElements;
		}

		const $root = this._get(this._getDomElement.bind(this), selector, forceRefresh);

		const $elements = $root.querySelectorAll(tag);

		this.elementMap[key] = $elements;

		return this.elementMap[key];
	}
}
